import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.SUPER_ADMIN };
const path = "admin/email-analytics";

/**
 * Fetch SendGrid email stats.
 * @param {string} startDate  – YYYY-MM-DD
 * @param {string} endDate    – YYYY-MM-DD
 * @param {string} aggregatedBy – day | week | month
 */
export const getEmailStats = async (startDate, endDate, aggregatedBy = "day") => {
  return axiosInstance(options).get(`${path}/stats`, {
    params: { start_date: startDate, end_date: endDate, aggregated_by: aggregatedBy },
  });
};
